const painPoints = [
  'Fixed a typo, forgot to update the French version',
  'Product name broke across two lines, failed review',
  'Uploading to Veeva takes 10 minutes for every single revision',
];

export const PainPoints = () => {
  return (
    <section className="relative py-24 px-6">
      {/* Subtle diagonal background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white -skew-y-1 transform origin-top-left" />

      <div className="relative max-w-3xl mx-auto">
        {/* Header with accent */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-rose-400/10 flex items-center justify-center">
            <svg className="w-6 h-6 text-rose-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Sound familiar?
          </h2>
        </div>

        {/* Pain points list */}
        <ul className="space-y-4">
          {painPoints.map((point, index) => (
            <li
              key={index}
              className="group flex items-start gap-4 p-5 rounded-xl bg-white border border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200 transition-all duration-300"
            >
              <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-gray-100 text-gray-400 flex items-center justify-center font-mono text-sm group-hover:bg-rose-400/10 group-hover:text-rose-400 transition-colors">
                {index + 1}
              </span>
              <span className="text-lg text-gray-700 leading-relaxed pt-0.5">
                {point}
              </span>
            </li>
          ))}
        </ul>

        {/* Decorative element */}
        <div className="absolute -right-4 top-1/2 -translate-y-1/2 hidden xl:block">
          <div className="w-px h-32 bg-gradient-to-b from-transparent via-rose-400/30 to-transparent" />
        </div>
      </div>
    </section>
  );
};
